/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import moment from '@/moment'
import { settings as calendarSettings } from '@/io.ox/calendar/settings'
import { DateTime } from 'luxon'

export function getWeekStart (date = moment(), weekStart = calendarSettings.get('workweekStart', 1)) {
  const firstDayOfWeek = moment.localeData(date.locale()).firstDayOfWeek()
  const localeWeekday = (weekStart - firstDayOfWeek + 7) % 7
  return date.clone().startOf('week').weekday(localeWeekday)
}

export function getMonday (date = moment()) {
  // even for a "standard" Monday, simple solutions like this would NOT work for all locales: date.startOf('week').day(1)
  return getWeekStart(date, 1)
}

export function scrollToCurrentTime (container, { smooth = false } = {}) {
  const now = DateTime.now()
  const minutes = Math.floor(now.diff(now.startOf('day')).as('minutes'))
  const y = minutes / 24 / 60
  // container.clientHeight / 2 would be the center; / 4 or * 0.20 is top 20% since users rather want to see future appointments
  const top = y * container.scrollHeight - (container.clientHeight * 0.20)
  container.scrollTo?.({ top, behavior: smooth ? 'smooth' : 'instant' })
}

export const ISO_FORMAT = 'yyyyMMdd\'T\'HHmmss'

export function getSelectedCalendarFolders () {
  const selectedFolders = calendarSettings.get('selectedFolders')
  return selectedFolders || [calendarSettings.get('chronos/defaultFolderId')]
}
